// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2021-06-11 13:25:01 +0200 (Fri, 11 Jun 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: o.powroznik $
//  Revision  : $Rev: 120136 $
//  Purpose   : I18N related parts
// =============================================================================
// ---Third-party imports
import React, {Component, Fragment} from 'react'
import {matchSorter} from 'match-sorter'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import log from 'uix/logging'
import {keys, values} from 'ldash'
import {HeaderSegment, Link, TranslatedTable, XMenu} from 'uix/components'
import {useSelector, useMemo, useActions, useState} from 'uix/hooks'

// ---Globals
const filterMethod = key => (filter, rows) => matchSorter(rows, filter.value, {keys: [key]})

export const I18NTable = ({dname, flex}) => {
  let dconfig = useSelector(Sel.dconfig)
  let i18n = useSelector(Sel.i18n)
  let switchLanguage = useActions(Actions.switchLanguage)
  let selectedLang = useSelector(root => root.meta.language)
  let [filtered, setFiltered] = useState(false)

  let dn = useSelector(root => root.meta.request.dname)
  dname = dname || dn

  let ddata = useSelector(root => root.config.ddata)
  let i18n_raw = ddata[dname].i18n
  if (!i18n_raw) {
    return null
  }

  const columns = [
    {
      Header: 'Ident',
      accessor: f => f,
      id: 'ident',
      filterMethod: filterMethod('ident'),
      filterAll: true, // for giving all rows to matchSorter
    },
  ]
  columns.push(
    ...keys(i18n_raw)
      .filter(lang => !filtered || lang == selectedLang)
      .map(lang => ({
        Header: lang,
        accessor: f => i18n_raw[lang][f],
        id: lang,
        filterMethod: filterMethod(lang),
        filterAll: true, // for giving all rows to matchSorter
      }))
  )

  let idents = useMemo(() => keys(values(i18n_raw)[0]), [i18n_raw])

  let langSwitchers = dconfig.language.supported.map(lang => (
    <XMenu.Item
      key={lang}
      active={selectedLang == lang}
      onClick={() => switchLanguage(lang)}
      content={i18n.get(`lang_${lang}`)}
    ></XMenu.Item>
  ))

  let menu = (
    <XMenu>
      <XMenu.Toggle
        icon="filter"
        title="show only one column for selected lang"
        set={setFiltered}
        value={filtered}
      />
      {langSwitchers}
    </XMenu>
  )

  return (
    <HeaderSegment header="Translations" icon="world" flex={flex} overflowInner menu={menu}>
      <TranslatedTable
        flex
        compact
        showPagination
        showPaginationTop
        showPaginationBottom={false}
        filterable={true}
        className="-striped -highlight dynHeight"
        data={idents}
        columns={columns}
      />
    </HeaderSegment>
  )
}
